

exports.__esModule = true;
exports.$xoSidebarCurrencyConversionPageComponent = undefined;

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

require('components/xo-page-components/src/aside-header/directive');

require('components/xo-wallet-components/src/currency-conversion/directive');

var _squid = require('squid');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoSidebarCurrencyConversionPageComponent = exports.$xoSidebarCurrencyConversionPageComponent = _squid.$Component.extend('$xoSidebarCurrencyConversionPageComponent', {
    tag: 'xo-sidebar-currency-conversion-page',
    template: _template2['default'],

    controller: function controller($scope, $rootScope, $state) {
        $scope.token = $rootScope.token;

        $scope.onComplete = function () {
            $state.go('checkout.review');
        };

        $scope.$emit('populated');
    }
});

angular.value("$xoSidebarCurrencyConversionPageComponent", $xoSidebarCurrencyConversionPageComponent);
_squid.$Component;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-sidebar-currency-conversion/directive.js
// module id = ./pages/xo-sidebar-currency-conversion/directive.js
// module chunks = 1